
























import Loading from "@/components/common/Loading.vue";
import { Component, Vue, Watch } from 'vue-property-decorator';
import HexabaseApi from '@/services/hexabase/hexabaseApi';
import authState from '@/store/auth';
import userState from '@/store/user';
import constructionState from '@/store/construction';

@Component({
  components: {
    Loading
  }
})
export default class App extends Vue {
  private hexabaseApi = new HexabaseApi();
  isLogined = false;
  userName = '';
  userEmail = '';

  // 画面遷移ごとに認証トークンを監視
  @Watch('$route', { immediate: true, deep: true })
  onUrlChange() {
    this.isLogined = authState.isLogin;
    this.userName = userState.getUserName;
    this.userEmail = userState.getUserEmail;
    if (this.isLogined && !this.$route.path.includes('/construction')) {
      // 画面遷移で工事案件管理以外の画面へ遷移した場合、保持していた工事案件検索条件をクリアする
      constructionState.clearSearchConditions();
    }
  }

  private async logout() {
    await this.hexabaseApi.logout(authState.token);
    authState.clearToken();
    userState.clearUserState();
    constructionState.clearSearchConditions();
    this.$router.push('/signin');
  }
}
